export function formatTimeInput(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 4)
  if (!digits) return ''
  if (digits.length <= 2) return digits
  const hh = Math.min(parseInt(digits.slice(0, 2), 10), 23)
    .toString()
    .padStart(2, '0')
  const mmDigits = digits.slice(2)
  const mm = mmDigits.length === 2 ? Math.min(parseInt(mmDigits, 10), 59).toString().padStart(2, '0') : mmDigits
  return `${hh}:${mm}`
}

export function isValidTime(time: string): boolean {
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(time)
}
